import { CallResult } from '@salesforce/scv-connector-base';
import { PhoneCallGenerator } from '@main/generators/phone-call.generator';
import type { CallType } from '@main/types/sf-types';

export class CallResultGenerator {
  static generate(
    callId: string,
    callType: CallType,
    phoneNumber: string,
  ): CallResult {
    return new CallResult({
      call: PhoneCallGenerator.generate(callId, callType, phoneNumber),
    });
  }
}
